import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../common/Header";
import $ from "jquery";
import useAuth from "../../../hooks/useAuth";
import Toastify from "../../common/Toastify";
import { POSTREQUEST } from "../../helpers/ServiceRequest";

function InsertCustomer() {
  const [StandardRebate, setStandardRebate] = useState("");
  const [standardRebateErr, setStandardRebateErr] = useState("");
  const [rebateCrates, setRebateCrates] = useState(0);
  const [priceListReqd, setPriceListReqd] = useState(0);
  const [invoiceSignatureReqd, setInvoiceSignatureReqd] = useState(0);
  const [showProductCode, setShowProductCode] = useState(0);
  const [RRP, setRRP] = useState(0);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [errors, setErrors] = useState({});
  const [customerData, setCustomerData] = useState({});
  const { user } = useAuth();

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomerData((prevData) => ({
      ...prevData,
      [name]: value
    }));

    if (Object.keys(errors).length > 0 && errors[name]) {
      setErrors((prevData) => {
        const updatedError = { ...prevData };
        delete updatedError[name];
        return updatedError;
      });
    }
  }

  const checkErrors = async () => {
    let isError = false;
    const fields = ['CustomerName',
      "CustomerContact",
      "EmailAddresses",
      "CustomerCode",
      "InvoiceAddress1",
      "InvoiceSuburb",
      "InvoiceState",
      "InvoicePostCode",
      "PrintOrder"
    ]

    fields.map((field) => {
      let value = customerData[field];
      if (!value) {
        setErrors((prevData) => ({
          ...prevData,
          [field]: true
        }));
        isError = true;
      } else {
        setErrors((prevData) => {
          const updatedError = { ...prevData };
          delete updatedError[field];
          return updatedError;
        });
      }
    });

    return isError;
  }

  let navigate = useNavigate();
  
  const addCustomer = async (e) => {
    e.preventDefault();
    const isError = await checkErrors();
    let URL = process.env.REACT_APP_API_URL + "/create-customer";
    
    if (Object.keys(errors).length > 0 || isError) {
      return false;
    }

    if(StandardRebate == "" || StandardRebate < 0){
      setStandardRebateErr(true);
      return false;
    }

    let payload = {
      ...customerData,
      StandardRebate: StandardRebate,
      RebateCrates: rebateCrates,
      PriceListReqd: priceListReqd,
      InvoiceSignatureReqd: invoiceSignatureReqd,
      ShowProductCode: showProductCode,
      RRP: RRP,
      Current: parseInt(customerData?.Current || 1),
      Category: customerData?.Category || ''
    };
    setMessage('');
    setMessageType('');
    let response = await POSTREQUEST(URL, payload, user.jwtToken);
    if (response?.data) {
      if (response.data.success) {
        setMessage(response.data.message);
        setMessageType('success');
        setTimeout(() => {
          navigate("/customers");
        }, 2000);
      } else {
        setMessage(response.data.message);
        setMessageType('error');
      }
    } else {
      setMessage(response?.error?.message || 'Failed to create Customer !!');
      setMessageType('error');
    }
  };
  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/customers"
                    className="text-decoration-none text-primary"
                  >
                    Customers
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Add New Customer
                </li>
              </ol>
            </nav>
          </div>
          <div className="card border-bottom-0">
            <div className="card-header bg-white d-flex align-items-center justify-content-between border-bottom-0 p-4">
              <h1 className="title-semibold fs-24 mb-0">Add Customer</h1>
            </div>
            <div className="card-body p-4 pt-3 border-bottom">
              <h2 className="title-medium title-semibold fs-16 mb-3">
                Customer Contact Information
              </h2>
              <form onSubmit={addCustomer}>
                <div className="row border-bottom pb-4">
                  <div className="width-xxl-34 width-xl-50 width-lg-80">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Customer Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md" +
                            (errors['CustomerName'] ? " is-invalid" : "")
                          }
                          placeholder="Enter customer name"
                          name="CustomerName"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Customer Contact
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md" +
                            (errors['CustomerContact'] ? " is-invalid" : "")
                          }
                          name="CustomerContact"
                          placeholder="Enter customer contact"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Fax Number
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-md"
                          name="FaxNumber"
                          placeholder="Enter fax number"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3 align-items-start">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Invoice Address
                      </label>
                      <div className="col">
                        <textarea
                          type="text"
                          className={
                            "form-control" +
                            (errors['InvoiceAddress1'] ? " is-invalid" : "")
                          }
                          name="InvoiceAddress1"
                          placeholder="Enter invoice address"
                          rows="3"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        ></textarea>
                      </div>
                    </div>

                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Suburb - State - PC
                      </label>
                      <div className="col">
                        <div className="row gx-2">
                          <div className="col-sm-6">
                            <input
                              type="text"
                              className={
                                "form-control input-md" +
                                (errors['InvoiceSuburb'] ? " is-invalid" : "")
                              }
                              name="InvoiceSuburb"
                              placeholder="Enter suburb"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                          <div className="col-sm-3">
                            <input
                              type="text"
                              className={
                                "form-control input-md" +
                                (errors['InvoiceState'] ? " is-invalid" : "")
                              }
                              name="InvoiceState"
                              placeholder="State"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                          <div className="col-sm-3">
                            <input
                              type="text"
                              placeholder="PC"
                              className={
                                "form-control input-md" +
                                (errors['InvoicePostCode'] ? " is-invalid" : "")
                              }
                              name="InvoicePostCode"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="width-xxl-34 width-xl-50 width-lg-80 ps-xl-5">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Customer Code
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          placeholder="Enter customer code"
                          className={
                            "form-control input-md" +
                            (errors['CustomerCode'] ? " is-invalid" : "")
                          }
                          name="CustomerCode"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Truck Address
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          placeholder="Enter truck address"
                          className="form-control input-md" 
                          name="TruckAddress"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>

                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Email Address
                      </label>
                      <div className="col">
                        <textarea
                          type="text"
                          placeholder="Enter email address"
                          rows="3"
                          className={
                            "form-control" +
                            (errors['EmailAddresses'] ? " is-invalid" : "")
                          }
                          name="EmailAddresses"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        ></textarea>
                      </div>
                    </div>
                    <div className="cmb-15 row g-3 align-items-start">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Invoice Address2
                      </label>
                      <div className="col">
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder="Enter invoice address2"
                          rows="3"
                          name="InvoiceAddress2"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        ></textarea>
                      </div>
                    </div>
                    <div className="cmb-15 row g-3 align-items-start">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Invoice Address3
                      </label>
                      <div className="col">
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder="Enter invoice address3"
                          rows="3"
                          name="InvoiceAddress3"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="spacer-4"></div>
                <h2 className="title-medium title-semibold fs-16 mb-3">
                  Other Information
                </h2>
                <div className="row">
                  <div className="width-xxl-34 width-xl-50 width-lg-80">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Buyer Code
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-md"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          name="BuyerCode"
                          placeholder="Enter buyer code "
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Standard Rebate
                      </label>
                      <div className="col">
                        <input
                          type="number"
                          className={
                            "form-control input-md" +
                            (standardRebateErr ? " is-invalid" : "")
                          }
                          onChange={(e) => {
                            setStandardRebateErr(false);
                            setStandardRebate(e.target.value);
                          }}
                          placeholder="Enter standard rebate"
                        />
                      </div>
                    </div>

                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Delivery <br /> Instructions
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-md"
                          name="DeliveryInstructions"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          placeholder="Enter delivery instructions"
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3 align-items-start">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Order Notes
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          placeholder="Enter order notes"
                          className="form-control input-md"
                          name="OrderNotes"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Rebate Crates
                      </label>
                      <div className="col">
                        <input
                          type="checkbox"
                          className="form-check-input pe-0"
                          id="remember"
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setRebateCrates(1);
                            } else {
                              setRebateCrates(0);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Price List Reqd?
                      </label>
                      <div className="col">
                        <input
                          type="checkbox"
                          className="form-check-input pe-0"
                          id="remember"
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setPriceListReqd(1);
                            } else {
                              setPriceListReqd(0);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        RRP
                      </label>
                      <div className="col">
                        <input
                          type="checkbox"
                          className="form-check-input pe-0"
                          id="remember"
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setRRP(1);
                            } else {
                              setRRP(0);
                            }
                          }}
                        />
                      </div>
                    </div>
                    {/* <div className="cmb-15 row g-3 align-items-start">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        RRP
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          placeholder="Enter RRP"
                          className={
                            "form-control input-md" +
                            (errors['RRP'] ? " is-invalid" : "")
                          }
                          name="RRP"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div> */}
                  </div>
                  <div className="width-xxl-34 width-xl-50 width-lg-80 ps-xl-5">
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Purchase Order
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          placeholder="Enter purchase order"
                          className="form-control input-md"
                          name="PurchaseOrder"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Print Order
                      </label>
                      <div className="col-sm-4">
                        <input
                          type="number"
                          className={
                            "form-control input-md" +
                            (errors['PrintOrder'] ? " is-invalid" : "")
                          }
                          name="PrintOrder"
                          placeholder="Enter print order"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>

                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Inv Signature Reqd?
                      </label>
                      <div className="col">
                        <input
                          type="checkbox"
                          className="form-check-input pe-0"
                          id="remember"
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setInvoiceSignatureReqd(1);
                            } else {
                              setInvoiceSignatureReqd(0);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Show Product Code?
                      </label>
                      <div className="col">
                        <input
                          type="checkbox"
                          className="form-check-input pe-0"
                          id="remember"
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setShowProductCode(1);
                            } else {
                              setShowProductCode(0);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Category
                      </label>
                      <div className="col-sm-4">
                        <select
                          className="form-select input-md"
                          aria-label="Default select example"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          name="Category"
                          value={customerData['Category']}
                        >
                          {!customerData['Category'] && <option disabled value={''}></option>}
                          <option value={'A'}>A</option>
                          <option value={'B'}>B</option>
                          <option value={'C'}>C</option>
                          <option value={'D'}>D</option>
                          <option value={'E'}>E</option>
                          <option value={'F'}>F</option>
                        </select>
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Status
                      </label>
                      <div className="col-sm-4">
                        <select
                          className="form-select input-md"
                          aria-label="Default select example"
                          name="Current"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          value={customerData['Current']}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col d-flex justify-content-end align-items-end">
                    <button
                      type="submit"
                      className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3"
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
export default InsertCustomer;
